import { EcommerceHead } from './EcommerceHead'

import { useOptionDataLayerObject } from '../../../hooks'

export const OptionIndexHead = () => {
  const dataLayerObject = useOptionDataLayerObject()

  return dataLayerObject && <EcommerceHead dataLayerObject={dataLayerObject} />
}
